import { COLORS, Color } from '@revolut/ui-kit'
import styled, { keyframes } from 'styled-components'
import { themeGet } from 'styled-system'

const getAnimation = (offset: number) => keyframes`
  from {
    stroke-dashoffset: 0;
  }

  to {
    stroke-dashoffset: ${offset};
  }
`

export const Container = styled.svg``

export const BackgroundCircle = styled.circle`
  stroke: ${COLORS[Color.GREY_TONE_10]};
  fill: transparent;
`

type AnimatedCircleProps = {
  strokeDasharray: number
  duration: number
}

export const AnimatedCircle = styled.circle<AnimatedCircleProps>`
  stroke: ${COLORS[Color.PRIMARY]};
  stroke-linecap: round;
  stroke-dashoffset: ${(props) => props.strokeDasharray};
  fill: transparent;

  animation-name: ${(props) => getAnimation(props.strokeDasharray)};
  animation-duration: ${(props) => props.duration}ms;
  animation-timing-function: linear;

  transform: rotate(270deg);
  transform-origin: center;
`

export const TimerText = styled.text`
  ${themeGet('textStyles.h4')}
`
